import React from 'react';
import Header from '../../../components/Header';
import Activities from '../../../components/Activities/Activity';
import OutageReqDetailsPage from './OutageReqDetailsPage';
import { useParams } from 'react-router-dom';

const OutageReqDetail = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <Header title={'Outage Requisition Details'} showBackButton={true} />

      <div className="grid grid-cols-12">
        {/* Main content */}
        <div className="col-span-8 px-6 py-6">
          <OutageReqDetailsPage />
        </div>

        {/* Vertical Divider */}
        <div className="col-span-1 flex justify-end">
          <div className="w-px bg-gray-200 h-full" />
        </div>

        {/* Activities Sidebar */}
        <div className="col-span-3.5 py-6 pr-6">
          <Activities moduleName="outage_requisitions" moduleItemId={Number(id)} />
        </div>
      </div>
    </div>
  );
};

export default OutageReqDetail;
